import type { PerformanceGraphResponse } from '@engage/api-v2-models/generated/PerformanceGraphResponse';
import type { BaseAPI, AxiosPromise } from '../generated/core/request';
import { getPerformanceGraph } from '../generated/services/WorkoutHistoryService';

export const getWorkoutPerformanceGraphWithHasAppleWatchMetrics = (
  api: BaseAPI,
  {
    workoutId,
    everyN,
    maxGapMeters,
    includeOutput,
    durationSummaryInSeconds,
    acceptLanguage,
    options = {},
  }: {
    workoutId: string;
    everyN?: number;
    maxGapMeters?: number;
    includeOutput?: boolean;
    durationSummaryInSeconds?: boolean;
    acceptLanguage?: string;
    options?: any;
  },
): AxiosPromise<
  PerformanceGraphResponse & {
    hasAppleWatchMetrics: boolean;
    caesarMetrics: { detail: { segments: any[]; score: number } };
  }
> =>
  getPerformanceGraph.apply(this, [
    api,
    workoutId,
    everyN,
    maxGapMeters,
    includeOutput,
    durationSummaryInSeconds,
    acceptLanguage,
    options,
  ]);
